import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subject, interval } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
import { NGXLogger } from "ngx-logger";

@Injectable({
  providedIn: 'root',
})
export class EventCollectorService {
  private events: any[] = [];
  private stopCollecting = new Subject<void>();
  private interval = 60000;
  private storageKey = 'pendingEvents';

  constructor(private router: Router, private logger: NGXLogger) {

  }

  startCollecting() {
    this.loadAndPostEvents();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.stopCollecting)
    ).subscribe(event => {
      this.events.push(event);
    });

    interval(this.interval).subscribe(() => {
      this.postEvents();
    });

    window.addEventListener('beforeunload', () => this.saveEvents());
  }

  saveEvents() {
    if (this.events.length > 0) {
      sessionStorage.setItem(this.storageKey, JSON.stringify(this.events));
    }
  }

  postEvents() {
    this.loadAndPostEvents();

    try {
      if (this.events.length > 0) {
        this.logger.info('Posting events:', this.events);
        this.events = [];
      }
    } catch (error) {
      this.logger.error('Posting events:', this.events);
    }
  }

  loadAndPostEvents() {
    try {
      const storedEvents = sessionStorage.getItem(this.storageKey);
      if (storedEvents) {
        const eventsToPost = JSON.parse(storedEvents);
        if (eventsToPost.length > 0) {
          this.logger.debug('Posting stored events:', eventsToPost);
          sessionStorage.removeItem(this.storageKey);
        }
      }
    } catch (error) {
      const storedEvents = sessionStorage.getItem(this.storageKey);
      if(storedEvents){
        const eventsToPost = JSON.parse(storedEvents);
        this.logger.error('Posting stored events:', eventsToPost);
      }
    }
  }

  stopCollectingEvents() {
    this.stopCollecting.next();
  }
}
